import { AnimatedBackground, Typewritter } from '../components/';

import './Landing.css';

let mesArr = [
  ' ',
  'A Web developer',
  'Also known as a',
  'Front-end Developer',
  'or!',
  '"a coder"',
  ' ',
];

function Landing() {
  return (
    <AnimatedBackground>
      <div className='landing-type'>
        <span>Who am I?</span>
        <Typewritter data={mesArr} />
      </div>
    </AnimatedBackground>
  );
}

export default Landing;
